<template>
    <a @click.prevent="openListing" :href="listingUrl" target="_blank" rel="nofollow">
        <slot />
    </a>
</template>

<script>
import ListingMixin from '../../mixins/listing';

export default {
    mixins: [ListingMixin],
    
    props: ['listing'],

    data: () => ({}),

    created() {},

    mounted() {},

    computed: {},

    methods: {}
}
</script>

<style lang="scss" scoped>
</style>
